import React from 'react';

import { isPrivateFolder } from '@libs/NwFolders';

import NwIcon from '@components/Gui/NwIcon';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

//il livello preciso non serve: basta distinguere una folder personale da una condivisa
const FolderPrivacyIcon = ({ folder, size }) => {
    const isPrivate = isPrivateFolder(folder);

    return (
        <NwIcon
            icon={isPrivate ? byPrefixAndName.fasl['lock'] : byPrefixAndName.fasl['users']}
            size={size}
            tooltip={isPrivate ? 'private folder' : 'shared folder'}
        />
    );
};

export default FolderPrivacyIcon;
